module.exports = __webpack_public_path__ + "static/media/TN-Men-Knit-v2.0-OA.6484ef95.svg";